import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';

@Component({
    selector: 'app-nutriscore',
    templateUrl: './nutriscore.component.html',
    styleUrls: ['./nutriscore.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NutriscoreComponent implements OnInit {
  @Input() score: string;

  constructor() {}

  ngOnInit(): void {}
}
